import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter } from '../../../global/commonStyle';

const ModalBottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  padding: var(--space-16);
`;

const Description = styled.p`
  margin: var(--space-0);
  ${Typography.body_lg}
  color: var(--text-secondary);
`;

const Form = styled.form`
  display: flex;
  gap: var(--space-12);
  flex-direction: column;
`;

const VerificationBox = styled.div`
  display: flex;
  gap: var(--space-12);
  flex-direction: column;
`;

const VerificationCode = styled.span`
  ${Typography.body_md_medium}
  color: var(--brand-primary);
  cursor: pointer;
`;

const ButtonDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
  justify-content: end;
`;

export { ModalBottom, Description, Form, VerificationBox, VerificationCode, ButtonDiv };
